export const DEFAULT_TENANT_ID = 'brighteon'
export const TENANT_ID = process.env.NEXT_PUBLIC_TENANT_ID || DEFAULT_TENANT_ID
